<template>
  <div>
    <a :href="getLink('facebook')" target="_blank">
      <img src="../assets/facebook_black.png" v-if="black" />
      <img src="../assets/facebook_color.png" v-else />
    </a>
    <a :href="getLink('twitter')" target="_blank">
      <img src="../assets/twitter_black.png" v-if="black" />
      <img src="../assets/twitter_color.png" v-else />
    </a>
    <a :href="getLink('pinterest')" target="_blank">
      <img src="../assets/pinterest_black.png" v-if="black" />
      <img src="../assets/pinterest_color.png" v-else />
    </a>
  </div>
</template>

<script>
export default {
  props: {
    name: String,
    target: Object,
    black: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getUrl() {
      return `${location.origin}/${this.name}/${this.target.id}/`;
    },
    getLink(type) {
      const url = encodeURIComponent(this.getUrl());
      const image =
        this.target.cover || this.target.banner || this.target.background;
      const media = encodeURIComponent(`${location.origin}${image}/`);

      if (type === "facebook") {
        return `https://www.facebook.com/sharer/sharer.php?u=${url}`;
      }

      if (type === "twitter") {
        return `https://twitter.com/intent/tweet?url=${url}`;
      }

      if (type === "pinterest") {
        return `http://pinterest.com/pin/create/button/?url=${url}&media=${media}`;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
img {
  width: 26px;
  margin: 0 5px;
}
</style>
